module.exports = __webpack_public_path__ + "media/images/proof_links/colored/tiktok-c95e0b0f8adef650cffd14b41a9b350d.svg";